import app from 'flarum/forum/app';
import TaxCalculatorPage from './components/TaxCalculatorPage';
import SalaryConverterPage from './components/SalaryConverterPage';
import BusinessTaxCalculatorPage from './components/BusinessTaxCalculatorPage';
import TaxGuidePage from './components/TaxGuidePage';
app.initializers.add('voucha-calculators', () => {
  app.routes['voucha.taxCalculator'] = {
    path: '/tax-calculator',
    component: TaxCalculatorPage
  };
  app.routes['voucha.salaryConverter'] = {
    path: '/salary-converter',
    component: SalaryConverterPage
  };

  // tax guides: the list, and one guide (taxGuides.js)
  app.routes['voucha.taxGuides'] = {
    path: '/tax',
    component: TaxGuidePage
  };
  app.routes['voucha.taxGuide'] = {
    path: '/tax/:slug',
    component: TaxGuidePage
  };
  app.routes['voucha.businessTax'] = {
    path: '/business-tax',
    component: BusinessTaxCalculatorPage
  };
});